import { createContext, useReducer, useContext } from 'react';
import TreeReducer from '../reducers/TreeReducer';
import TreeState from '../data/state/TreeState';

const TreeStateContext = createContext(TreeState);
const TreeDispatchContext = createContext(null);

function TreeContextProvider({ children }) {
  const [state, dispatch] = useReducer(TreeReducer, TreeState);
  return (
    <TreeStateContext.Provider value={state}>
      <TreeDispatchContext.Provider value={dispatch}>
        {children}
      </TreeDispatchContext.Provider>
    </TreeStateContext.Provider>
  );
}

export default TreeContextProvider;

export const useTreeStateContext = () => useContext(TreeStateContext);
export const useTreeDispatchContext = () => useContext(TreeDispatchContext);